module.exports = __webpack_public_path__ + "img/T6-B-22.d215883d.png";